import { render, staticRenderFns } from "./CorrectDataTable.vue?vue&type=template&id=c6d7dc3e&"
import script from "./CorrectDataTable.vue?vue&type=script&lang=js&"
export * from "./CorrectDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CorrectDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VDataFooter,VDataTable})
